import { render } from "./Typography.vue?vue&type=template&id=dce7eb02&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"

import "./Typography.vue?vue&type=style&index=0&id=dce7eb02&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce7eb02"]])

export default __exports__